import { api } from '@services/api'
import {
  ClinicalSafetyEventDetail,
  ClinicalSafetyEventListResponse,
  ClinicalSafetyEventStatus,
  ClinicalSafetyEventStatusUpdate,
  ClinicalSafetyEventSeverity,
} from '@/types'

interface ClinicalSafetyListParams {
  patient_id?: string
  owner_role?: string
  status?: ClinicalSafetyEventStatus
  severity?: ClinicalSafetyEventSeverity
  skip?: number
  limit?: number
}

export const clinicalSafetyApi = {
  getInbox: (includeClosed = false, skip = 0, limit = 100) =>
    api.get<ClinicalSafetyEventListResponse>(
      `/safety/inbox?include_closed=${includeClosed}&skip=${skip}&limit=${limit}`
    ),

  getEvents: (params: ClinicalSafetyListParams = {}) => {
    const query = new URLSearchParams()
    if (params.patient_id) query.set('patient_id', params.patient_id)
    if (params.owner_role) query.set('owner_role', params.owner_role)
    if (params.status) query.set('status', params.status)
    if (params.severity) query.set('severity', params.severity)
    query.set('skip', String(params.skip ?? 0))
    query.set('limit', String(params.limit ?? 100))
    return api.get<ClinicalSafetyEventListResponse>(`/safety/events?${query.toString()}`)
  },

  getEvent: (eventId: string) =>
    api.get<ClinicalSafetyEventDetail>(`/safety/events/${eventId}`),

  updateStatus: (eventId: string, payload: ClinicalSafetyEventStatusUpdate) =>
    api.patch<ClinicalSafetyEventDetail>(`/safety/events/${eventId}/status`, payload),
}
